/* eslint-disable @stencil-community/strict-boolean-conditions */
import { Component, h, Host, Prop } from '@stencil/core';
import SvgIconSelection from '@bitgmbh/ebiz-icons/lib/icons/selection.json';

interface SvgSelectionItem {
  id: string;
  title: string;
  fileName: string;
  space: string;
  viewBox: string;
  svgPaths: string[];
}

type SvgSelection = Record<string, SvgSelectionItem>;

@Component({
  tag: 'baywa-icon',
  styleUrl: 'baywa-icon.scss',
  shadow: true,
})
export class BaywaIcon {
  /**
   * The color to use for the icon
   */
  @Prop() color: string = '';
  /**
   * The icon symbol's ID; see Storybook => Iconography
   */
  @Prop() icon!: string;
  /**
   * The size of the icon
   */
  @Prop() size: string = '';
  /**
   * The title to use for accessibility
   */
  @Prop({ attribute: 'title' }) iconTitle: string;

  render() {
    const svgItem = (SvgIconSelection as unknown as SvgSelection)[this.icon];
    if (svgItem == undefined) {
      return null;
    }
    const addedStyles = {};
    let hasAddedStyles: boolean = false;
    if (this.size) {
      addedStyles['--icon-size'] = this.size;
      hasAddedStyles = true;
    }
    if (this.color) {
      addedStyles['fill'] = this.color;
      hasAddedStyles = true;
    }

    return (
      <Host {...(hasAddedStyles ? { style: addedStyles } : null)}>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox={svgItem.viewBox}>
          {svgItem.svgPaths.map((d, idx) => (
            <path key={idx} d={d} />
          ))}
        </svg>
      </Host>
    );
  }
}
